import React from 'react';
import { useParameterizedQuery } from 'react-fetching-library';
import { useDispatch } from 'react-redux';
import { Button, Menu, MenuItem, Divider, ListItem, ListItemIcon, ListItemText, ListItemButton, IconButton, Tooltip, Portal } from '@mui/material';
import { SnackbarAlert } from '../../../../../../components-core/SnackbarAlert';
import { createAgreementAnnexAction, sendAgreementAnnexAction } from '../../../../../../services/request';
import { updateOrder } from '../../../../../../services/redux-actions';
import AddIcon from '@mui/icons-material/Add';
import ForwardToInboxIcon from '@mui/icons-material/ForwardToInbox';

const AgreementButton = ({ order, getDocument }) => {
  const dispatch = useDispatch();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [snackbar, setSnackbar] = React.useState({ open: false, severity: 'error', message: 'Wystąpił błąd' });
  const { query } = useParameterizedQuery(createAgreementAnnexAction);
  const { query: sendQuery } = useParameterizedQuery(sendAgreementAnnexAction);
  const open = Boolean(anchorEl);

  const handleCloseSnackbar = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbar(prev => ({ ...prev, open: false }));
  };

  const handleOpenSnackbar = (severity, message) => setSnackbar({ open: true, severity, message });

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
    console.log(order);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleCreateAnnex = async () => {
    const { payload, error, loading } = await query(order.id);
    if (!error && !loading) {
      dispatch(updateOrder(payload));
      handleOpenSnackbar('success', 'Utworzono aneks');
    }

    if (error) {
      handleOpenSnackbar('error', 'Nie udało się utworzyć aneksu');
    }
  };

  const handleSendAnnex = async annex_id => {
    const { error, loading } = await sendQuery(order.id, annex_id);
    if (!error && !loading) {
      handleOpenSnackbar('success', 'Email został wysłany');
    }

    if (error) {
      handleOpenSnackbar('error', 'Nie udało się wysłać aneksu');
    }
  };

  return (
    <>
      <Button
        id="basic-button"
        aria-controls={open ? 'basic-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
        variant="contained"
        disabled={order.state !== 'CON'}
      >
        Umowa lub ostatni aneks
      </Button>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button'
        }}
      >
        <MenuItem onClick={handleCreateAnnex} >
          <ListItemIcon>
            <AddIcon />
          </ListItemIcon>
          <ListItemText>
              Dodaj aneks
          </ListItemText>
        </MenuItem>
        <Divider />
        <MenuItem onClick={() => getDocument('agreement', 'umowa')}>{order.agreement_number}</MenuItem>
        {order.order_annexes.map(annex => (
          <ListItem
            key={annex.id}
            disablePadding
            secondaryAction= {
              <Tooltip title="wyślij dokument do klienta" placement="right-start">
                <IconButton edge="end" aria-label="comments" onClick={() => handleSendAnnex(annex.id)}>
                  <ForwardToInboxIcon color="primary"/>
                </IconButton>
              </Tooltip>
            }
          >
            <ListItemButton
              onClick={() => getDocument('agreement_annex', `Aneks nr ${annex.number} do umowy ${order.agreement_number}`, annex.id)}
            >
              <ListItemText>Aneks nr {annex.number}</ListItemText>
            </ListItemButton>
          </ListItem>))}
      </Menu>
      <Portal>
        <SnackbarAlert open={snackbar.open} severity={snackbar.severity} message={snackbar.message} onClose={handleCloseSnackbar} />
      </Portal>
    </>
  );
};


export default AgreementButton;
